module.exports = __webpack_public_path__ + "img/icon-hour.0812dbbb.svg";